import { useParams, Link } from 'react-router-dom';
import { Row, Col, ListGroup, Card } from 'react-bootstrap';
import { useGetRentDetailsQuery } from '../slices/rentsApiSlice';
import Loader from '../components/Loader';
import Message from '../components/Message';
import Meta from '../components/Meta';

const RentScreen = () => {
  const { id: rentId } = useParams();
  const { data: rent, isLoading, error } = useGetRentDetailsQuery(rentId);

  const renderRentDetails = () => (
    <>
      <Meta title={`Rent - ${rent.tenant?.name || 'Details'}`} description={`Rent for ${rent.house?.name}`} />
      <Row>
        <Col md={6}>
          {rent.images && rent.images.length > 0 ? (
            <div className="mb-3">
              <h5>Contract Images</h5>
              <div className="d-flex flex-wrap gap-2">
                {rent.images.map((img, index) => (
                  <img
                    key={index}
                    src={img}
                    alt={`Rent ${index + 1}`}
                    style={{
                      width: '100px',
                      height: '100px',
                      objectFit: 'cover',
                      borderRadius: '5px',
                    }}
                  />
                ))}
              </div>
            </div>
          ) : (
            <Message variant="info">No images available for this rent record</Message>
          )}
        </Col>

        <Col md={3}>
          <ListGroup variant="flush">
            <ListGroup.Item>
              <h3>Tenant: {rent.tenant?.name}</h3>
            </ListGroup.Item>
            <ListGroup.Item>Start Date: {rent.startDate?.substring(0, 10)}</ListGroup.Item>
            <ListGroup.Item>End Date: {rent.endDate?.substring(0, 10)}</ListGroup.Item>
            <ListGroup.Item>Last Rent End: {rent.lastRentEnd?.substring(0, 10) || '—'}</ListGroup.Item>
            <ListGroup.Item>Monthly Rent: {rent.monthlyRent?.toLocaleString()}</ListGroup.Item>
            <ListGroup.Item>Months: {rent.numberOfMonths}</ListGroup.Item>
            <ListGroup.Item>Total Rent: {rent.totalRent?.toLocaleString()}</ListGroup.Item>
            <ListGroup.Item>Date Paid: {rent.datePaid?.substring(0, 10) || '—'}</ListGroup.Item>
            <ListGroup.Item>Recorded At: {rent.date?.substring(0, 10)}</ListGroup.Item>
            <ListGroup.Item>Remark: {rent.remark || '—'}</ListGroup.Item>
          </ListGroup>
        </Col>

        <Col md={3}>
          <Card>
            <ListGroup variant="flush">
              <ListGroup.Item>
                <Row>
                  <Col>House:</Col>
                  <Col>{rent.house?.name}</Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>Landlord:</Col>
                  <Col>{rent.landlord?.name}</Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>Address:</Col>
                  <Col>{rent.address}</Col>
                </Row>
              </ListGroup.Item>
            </ListGroup>
          </Card>
        </Col>
      </Row>
    </>
  );

  return (
    <>
      <Link className="btn btn-light my-3" to="/admin/rentlistscreen">
        Go Back
      </Link>
      {isLoading ? (
        <Loader />
      ) : error ? (
        <Message variant="danger">{error?.data?.message || error.error}</Message>
      ) : (
        renderRentDetails()
      )}
    </>
  );
};

export default RentScreen;